import { useCartContentCtx } from '../contexts/CartContentProvider'

/**
 * Returns the current count of the individual product present in the order.
 * Curried function – takes `cartContent` as 1st argument, `productId` as a 2nd one.
 */
const getProductCount = (cartContent: ReturnType<typeof useCartContentCtx>) => (productId: ID) => {
  const currentCartItem =
    cartContent && cartContent.items.filter((item) => item.product.id === productId)

  const productCount = currentCartItem?.length ?? 0

  return productCount
}

/**
 * Returns the `getProductCount` function
 * that will return the current count of the individual product present in the order.
 *
 * Use it when working with multiple products in a single component.
 */
export const useProductCountGetter = () => {
  const cartContent = useCartContentCtx()

  return getProductCount(cartContent)
}

/**
 * Returns the current count of the individual product present in the order.
 *
 * Use in a single-product component.
 */
export const useProductCount = (productId: ID) => {
  const getProductCount = useProductCountGetter()

  return getProductCount(productId)
}
